import { CommonModalProps } from 'components/CommonModal/context';
import { ModalCloseOptions } from 'constants/modals/modalCloseOptions';
import { ModalSeverityValues } from 'constants/modals/modalSeverityValues';

const confirmCancelAmendOrderModal: CommonModalProps = {
  id: 'confirmCancelAmendOrderModal',
  buttons: [
    {
      buttonText: 'Yes, cancel changes',
      buttonValue: ModalCloseOptions.OK,
    },
    {
      buttonText: 'Continue shopping',
      buttonValue: ModalCloseOptions.CANCEL,
    },
  ],
  buttonOrientation: 'vertical',
  messageText: [
    'Are you sure you want to cancel your changes to this order?',
    'Your order will revert back to its previous state.',
  ],
  titleText: 'Cancel changes?',
  severity: ModalSeverityValues.INFO,
};

export default confirmCancelAmendOrderModal;
